// Product API (everything except platform `/me/access` + `/brand-settings`).
// Single source of truth for the Ginja service base URL.
export const baseURL = "https://service.ginja.ai/sandbox/api/v1/";

// Some parts of the app call v2 endpoints; keep them on the same host.
export const baseURLV2 = baseURL.replace("/api/v1/", "/api/v2/");

